// extracted by mini-css-extract-plugin
export default {"reviewBox":"ReviewBox_reviewBox__6fN9E"};